var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('h1',[_vm._v("403 - Forbidden")]),_c('p',[_vm._v("Access to this resource is denied. Please contact the administrator if you think you should be allowed.")])])
}]

export { render, staticRenderFns }